import { render, staticRenderFns } from "./Swiper.vue?vue&type=template&id=6854a16e&"
import script from "./Swiper.vue?vue&type=script&lang=ts&"
export * from "./Swiper.vue?vue&type=script&lang=ts&"
import style0 from "./Swiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports